export const CONTACTS = {
  phoneDisplay: '+380 98 760 28 04',
  phoneHref: 'tel:+380987602804',
  telegramHandle: '@sofiteaches',
  telegramUrl: 'https://t.me/sofiteaches',
} as const;
